import { useQuery } from '@tanstack/react-query';
import * as api from '../api/reports';

export const useInventoryValuation = () =>
  useQuery({
    queryKey: ['reports', 'valuation'],
    queryFn: () => api.getInventoryValuation(),
  });

export const useStockMovement = (params) =>
  useQuery({
    queryKey: ['reports', 'stock-movement', params],
    queryFn: () => api.getStockMovement(params),
  });

export const useLowStockReport = () =>
  useQuery({
    queryKey: ['reports', 'low-stock'],
    queryFn: () => api.getLowStockReport(),
  });

export const useExpiryForecast = () =>
  useQuery({
    queryKey: ['reports', 'expiry-forecast'],
    queryFn: () => api.getExpiryForecast(),
  });

export const useDeadStock = (days) =>
  useQuery({
    queryKey: ['reports', 'dead-stock', days],
    queryFn: () => api.getDeadStock(days),
  });

export const useShrinkage = (params) =>
  useQuery({
    queryKey: ['reports', 'shrinkage', params],
    queryFn: () => api.getShrinkage(params),
  });
